import { isPlainObject } from 'shared/utils/object';

/**
 * Wake-up handshake between the page and the service worker: the page posts
 * `ping` with `ServiceWorker.postMessage` (which starts a stopped worker) and
 * the worker answers `pong` on the transferred port.
 */
export enum ServiceWorkerWakeMessageType {
  ping = 'HUSTRO_SW_PING',
  pong = 'HUSTRO_SW_PONG',
}

export function isServiceWorkerPingMessage(data: unknown): boolean {
  return (
    isPlainObject(data) && data.type === ServiceWorkerWakeMessageType.ping
  );
}

/** Which worker instance answered the ping: a new `swStartedAt` means the worker was restarted. */
export interface ServiceWorkerPongDetails {
  swStartedAt: number;
  swVersion: string;
}

export function createServiceWorkerPong(details: ServiceWorkerPongDetails): ServiceWorkerPongDetails & {
  type: ServiceWorkerWakeMessageType.pong;
} {
  return { type: ServiceWorkerWakeMessageType.pong, ...details };
}

/** The details of a pong; `undefined` from a worker that sends none (an older sw.js). */
export function readServiceWorkerPongDetails(data: unknown): ServiceWorkerPongDetails | undefined {
  if (!isPlainObject(data) || typeof data.swStartedAt !== 'number' || typeof data.swVersion !== 'string') {
    return undefined;
  }
  return { swStartedAt: data.swStartedAt, swVersion: data.swVersion };
}
